module.exports = __webpack_public_path__ + "img/stock2.5b192686.png";